import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import Button from '../../atoms/Button';
import { COLOR_SYSTEM } from '../../design/design-system';
import { getDocumentTypeFromRefId, DocumentType } from '../../../utils/documentTypeUtils';

// 문서 타입별 색상 및 스타일 정의
const getButtonStyleByType = (docType: DocumentType) => {
  switch (docType) {
    case "BEERS2023":
      return {
        color: COLOR_SYSTEM.get("Orange")?.[500],
      };
    case "SPSTv3":
    case "SPSTv2":
      return {
        color: COLOR_SYSTEM.get("Green")?.[500],
      };
    case "CCMM":
    case "LCMM":
      return {
        color: COLOR_SYSTEM.get("Purple")?.[500],
      };
    case "POLY":
      return {
        color: COLOR_SYSTEM.get("Brown")?.[500],
      };
    case "KABS":
      return {
        color: COLOR_SYSTEM.get("Skyblue")?.[500],
      };
    case "LABEL":
    default:
      return {
        color: COLOR_SYSTEM.get("Blue")?.[500],
      };
  }
};

const ReferenceButton: React.FC<NodeViewProps> = ({ node, extension }) => {
  const referenceId = node.attrs.referenceId;
  const text = node.attrs.text;
  
  if (!referenceId) {
    return null;
  }
  
  const docType = getDocumentTypeFromRefId(referenceId);
  const buttonStyle = getButtonStyleByType(docType);
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // onReferenceClick을 options에서 가져오기
    const onReferenceClick = (extension.options as any).onReferenceClick;
    if (onReferenceClick) {
      onReferenceClick(referenceId);
    }
  };
  
  return (
    <NodeViewWrapper 
      as="span" 
      style={{ display: 'inline' }}
      contentEditable={false}
    >
      <Button
        type="Text"
        size="Small"
        color="Primary"
        variant="Ghost"
        onClick={handleClick}
        data-reference-id={referenceId}
        data-reference-link="true"
        style={{
          margin: "0 1px",
          padding: "0 2px",
          fontSize: 12,
          color: buttonStyle.color,
          borderRadius: "2px",
          fontWeight: 500,
          maxHeight: "1.6rem",
          lineHeight: "1.2",
        }}
      >
        {text}
      </Button>
    </NodeViewWrapper>
  );
};

export default ReferenceButton;